import { faArrowLeftLong, faArrowRightLong } from '@fortawesome/pro-solid-svg-icons';
import Button from 'Components/Atoms/Button/Button';
import FontAwesomeIcon from 'Components/Atoms/FontAwesomeIcon/FontAwesomeIcon';
import { useTable } from 'Services/Table/TableContext';
import styles from './TableFooter.module.sass';
import {useEffect} from 'react';

const TableFooter = ({
    ...props
}: Props) => {
    const {
        state: { pageNumber, totalPageNumbers },
        setPageNumber
    } = useTable();

    const handlePrev = () => {
        let prevNumber = pageNumber - 1;
        if (prevNumber <= 0) prevNumber = 1;

        setPageNumber(prevNumber);
    };

    const handleNext = () => {
        let nextNumber = pageNumber + 1;
        if (nextNumber >= totalPageNumbers) nextNumber = totalPageNumbers;

        setPageNumber(nextNumber);
    }

    return <div className={styles['tablefooter']}>
        <Button
            size='small'
            variant='transparent'
            color='primary'
            iconBefore={<FontAwesomeIcon icon={faArrowLeftLong} />}
            isDisabled={pageNumber <= 1}
            onClick={handlePrev}
        >
            Vorige
        </Button>

        <div className={styles['tablefooter__pagination']}>
            PAGINA { pageNumber } VAN { totalPageNumbers ?? '1' }
        </div>
        
        <Button
            size='small'
            variant='transparent'
            color='primary'
            iconAfter={<FontAwesomeIcon icon={faArrowRightLong} />}
            isDisabled={pageNumber >= totalPageNumbers}
            onClick={handleNext}
        >
            Volgende
        </Button>
    </div>;
}

interface Props {

}

export default TableFooter;